import { OLModal } from "components/Tooltips/OLModal";
import OverflowChipTooltip from "components/Tooltips/OverflowChipTooltip";
import { useMessage } from "hooks/intl";
import { KeyValuePair } from "utilities/objects";
import { useStyles } from "./SingleTransaction.styles";

export const CustomAttributesModal = ({
  open,
  close,
  customAttributes,
}: {
  open: boolean;
  close: (val: boolean) => void;
  customAttributes: KeyValuePair[] | undefined;
}) => {
  const classes = useStyles();
  const { message } = useMessage();

  const anyCustomAttributeExists =
    customAttributes && customAttributes.length > 0;

  return (
    <OLModal
      open={open}
      header={message({ id: "customAttributes" })}
      submitText={message({ id: "close" })}
      submitAction={() => close(false)}
      onClose={() => close(false)}
      className={`${classes.customAttributesModal} ${classes.scrollable}`}
    >
      <div className={classes.chipsContainer}>
        {anyCustomAttributeExists &&
          customAttributes.map((label: KeyValuePair, index: number) => {
            const chipValue = `${label.key}: ${label.value}`;

            return (
              <OverflowChipTooltip
                label={chipValue}
                placement="top"
                data-test-id={`custom-attribute-modal-${index}`}
              />
            );
          })}
      </div>
    </OLModal>
  );
};
